import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export abstract class UiBlockService {
  abstract show: () => void;
  abstract hide: () => void;
}
